module.exports = __webpack_public_path__ + "media/components/Influencers/Oauths/New/StepPage/instagram_facebook-148a349d2481d4d553fb512472d67b36.svg";